import { PRESETS } from "./presets.js";
export const TYPE_SCALE = {
    xs: "0.75rem", // 12 — caption
    sm: "0.875rem", // 14 — meta
    base: "1rem", // 16 — body
    lg: "1.125rem", // 18 — lede
    xl: "1.5rem", // 24 — h3
    "2xl": "2rem", // 32 — h2
    "3xl": "2.5rem", // 40 — h1
    "4xl": "3.5rem", // 56 — hero
};
export const SPACING_SCALE = {
    0: "0",
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    6: "1.5rem",
    8: "2rem",
    12: "3rem",
    16: "4rem",
    24: "6rem",
};
export const RADIUS = {
    none: "0",
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "20px",
    pill: "9999px",
};
export const WEB_DENSITY = {
    airy: { sectionPaddingY: "5rem", sectionPaddingX: "3rem", cardPadding: "2rem", gap: "2rem" },
    generous: { sectionPaddingY: "4rem", sectionPaddingX: "2.5rem", cardPadding: "1.5rem", gap: "1.5rem" },
    dense: { sectionPaddingY: "2.5rem", sectionPaddingX: "1.5rem", cardPadding: "1.25rem", gap: "1rem" },
};
export function makeChartPalette(name) {
    const p = PRESETS[name];
    return {
        primary: p.accent1,
        secondary: p.accent2,
        series: p.palette.slice(0, 6),
        grid: p.grid,
        axis: p.text,
    };
}
/** preset → CSS variable map (root 에 inline 으로 박아 넣는 형태) */
export function presetToCssVars(name) {
    const p = PRESETS[name];
    const d = WEB_DENSITY[p.density];
    return {
        "--re-bg": p.bg,
        "--re-surface": p.surface,
        "--re-text": p.text,
        "--re-a1": p.accent1,
        "--re-a2": p.accent2,
        "--re-grid": p.grid,
        "--re-font-heading": `"${p.heading_font}", system-ui, sans-serif`,
        "--re-font-body": `"${p.body_font}", system-ui, sans-serif`,
        "--re-section-py": d.sectionPaddingY,
        "--re-section-px": d.sectionPaddingX,
        "--re-card-p": d.cardPadding,
        "--re-gap": d.gap,
    };
}
/** Google Fonts <link href> 빌더 — preset 별 1회 호출. */
export function googleFontsHref(name) {
    const p = PRESETS[name];
    const family = (font, weight) => `${font.replace(/ /g, "+")}:wght@${weight}`;
    const params = new Set([family(p.heading_font, p.heading_weight), family(p.body_font, p.body_weight)]);
    return `https://fonts.googleapis.com/css2?${[...params].map((s) => `family=${s}`).join("&")}&display=swap`;
}
